<template>
    <div
        v-tooltip="{content: isActive ? 'Remove Favorite' : 'Favorite', hideOnTargetClick: false}"
        aria-label="Favorite"
        @click.prevent="toggle"
    >
    <div class="saveIcon__icon">
    	<img class="saveIcon__image" :src="isActive ? '/images/frontend/thumbsup.png' : '/images/frontend/thumbsup-inactive.png'" alt="Favorite Icon" />
    </div>
        <!-- <i
            class="fa-thumbs-up"
            :class="isActive ? 'fas' : 'fal'"
        /> -->
    </div>
</template>

<script>
export default {
    name: 'FavoriteAction',
    props: {
        isFavorite: {
            type: Boolean,
            required: true,
        },
        itemId: {
            required: true,
        },
        itemType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isActive: false,
        };
    },
    computed: {
        parameterName() {
            if (this.itemType === 'resource') {
                return 'resource_id';
            }
            if (this.itemType === 'shortcut') {
                return 'shortcut_id';
            }

            return null;
        },

        actionUrl() {
            if (this.itemType === 'resource') {
                return '/api/resource-bookmarks/toggle';
            }
            if (this.itemType === 'shortcut') {
                return '/api/shortcut-bookmarks/toggle';
            }

            return null;
        },
    },
    mounted() {
        if (this.isFavorite) {
            this.isActive = true;
        }
    },
    methods: {
        toggle() {
            axios.post(this.actionUrl, { [this.parameterName]: this.itemId })
                .then((response) => {
                    if (response.data.success) {
                        this.isActive = response.data.isSaved;
                    }
                })
                .catch((e) => console.log(e));
        },
    },
};
</script>
